import './theme/icons';
import i18n from './i18n';

import SocketProvider from 'contexts/socketcontext/socket-provider';
import React from 'react';
import { AuthProvider } from 'services/auth';
import ReactDOM from 'react-dom';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { getApiErrorMessage } from 'utils/api-error';
import { notify } from 'utils/notify';

import App from './App';
import MutateThemeProvider from './providers/mutate-theme-provider';
import * as serviceWorker from './serviceWorker';

// Central error surfacing: EVERY query/mutation failure shows the real
// (network / GraphQL / REST) message, de-duplicated by useAlert. Feature code
// must not toast the same failure again.
const notifyError = (error: unknown) => notify(getApiErrorMessage(error, i18n.t.bind(i18n)), 'error');

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: notifyError }),
  mutationCache: new MutationCache({ onError: notifyError }),
});
const ENVIRONMENT = import.meta.env.VITE_ENV || 'STAGING';

ReactDOM.render(
  <MutateThemeProvider>
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <SocketProvider>
            <App />
          </SocketProvider>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  </MutateThemeProvider>,
  document.getElementById('root')
);

serviceWorker.register();
